/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingMenuErrorState, GroundingMenuErrorSlots } from './GroundingMenuError.types';

/**
 * Render the final JSX of GroundingMenuError
 */
export const renderGroundingMenuError_unstable = (state: GroundingMenuErrorState): JSXElement => {
  assertSlots<GroundingMenuErrorSlots>(state);

  return (
    <state.root>
      {state.image && <state.image />}
      {state.heading && <state.heading />}
      {state.body && (
        <state.body>
          {state.body.children}
          {state.root.children}
        </state.body>
      )}
    </state.root>
  );
};
